// เซิร์ฟเวอร์ไม่ได้ส่ง Cache-Control มาให้ index.html เบราว์เซอร์จึงเดาอายุแคชเอง
// (ราว 10% ของอายุนับจาก Last-Modified) หลังดีพลอยผู้ใช้จึงยังรัน index.html
// และบันเดิลตัวเก่าต่อไปจนกว่าแคชจะหมดอายุ ยิ่งไฟล์เก่ายิ่งค้างนาน
//
// วิธีตรวจ: ดึง index.html ใหม่แบบ no-store ซึ่งข้าม HTTP cache ทั้งหมด
// แล้วเทียบชื่อ bundle ในนั้นกับตัวที่กำลังรันอยู่ ถ้าไม่ตรงแปลว่ามีของใหม่
//
// เดิมโค้ดเทียบ process.env.VUE_APP_VERSION_FRONT กับค่าใน localStorage
// ซึ่งตรวจจับการดีพลอยไม่ได้เลย เพราะค่านั้นถูกฝังลงบันเดิลตอนบิลด์
// บันเดิลเก่าจึงอ่านได้แต่เลขเวอร์ชันของตัวเอง เทียบยังไงก็เท่ากันเสมอ

const BUNDLE_PATTERN = /app\.[a-z0-9]+\.bundle\.js/i;

// กัน reload วนไม่รู้จบ ถ้าโหลดใหม่แล้วยังได้บันเดิลเดิมอยู่
// แปลว่าดึงเอกสารใหม่ไม่สำเร็จ สั่งซ้ำไปก็ไม่ช่วย
//
// ผูกชื่อ key กับ BASE_URL เพราะ parent (/) กับ child (/back-office/)
// อยู่ origin เดียวกันในแท็บเดียวกัน จึงแชร์ sessionStorage กัน
// ถ้าใช้ key เดียวกันทั้งคู่ ต่างฝ่ายจะเขียนทับ guard ของกันและกัน
const GUARD_KEY = `reloaded_for_bundle:${process.env.BASE_URL || "/"}`;

const getRunningBundle = () => {
  const match = Array.from(document.querySelectorAll("script[src]"))
    .map((s) => s.getAttribute("src").match(BUNDLE_PATTERN))
    .find(Boolean);

  return match ? match[0] : null;
};

const cacheBuster = (bundle) => bundle.replace(/[^a-z0-9]/gi, "");

// แอปที่ทุก path ถูก fallback ไป index.html ของตัวเองอยู่แล้ว โหลด URL เดิมซ้ำได้เลย
// เติม _v เพื่อให้เป็น URL ที่ไม่เคยอยู่ในแคช เอกสารจึงถูกดึงใหม่แน่นอน
// ไม่พึ่งพฤติกรรม revalidate ของ reload ซึ่งต่างกันในแต่ละเบราว์เซอร์
export const reloadCurrentUrl = (bundle) => {
  const url = new URL(window.location.href);
  url.searchParams.set("_v", cacheBuster(bundle));
  return url.toString();
};

// สำหรับแอปที่อยู่ใต้ sub-path เช่น /back-office/
// nginx มีแค่ try_files $uri $uri/ /index.html ไม่มี fallback แยกให้ sub-path
// การโหลด /back-office/custom-survey/survey-list ตรง ๆ จึงได้ index.html ของ
// แอปที่อยู่ root แทน ซึ่งจะกลายเป็นแอปผิดตัวโผล่มาใน iframe
//
// จึงต้องกลับไปที่ entry ของตัวเอง (/back-office/ ซึ่ง $uri/ จับได้)
// แล้วส่ง path เดิมไปทาง query page ซึ่งเป็นวิธีเดียวกับที่ parent เปิด iframe อยู่แล้ว
export const reloadViaEntryPage = (bundle) => {
  const base = process.env.BASE_URL || "/";
  const url = new URL(window.location.href);

  const page = url.pathname.startsWith(base)
    ? url.pathname.slice(base.length - 1)
    : "/";

  url.pathname = base;
  url.searchParams.set("page", page);
  url.searchParams.set("_v", cacheBuster(bundle));

  return url.toString();
};

export default async function checkAppVersion(buildReloadUrl = reloadCurrentUrl) {
  const running = getRunningBundle();
  if (!running) return;

  let html;
  try {
    const response = await fetch(`${process.env.BASE_URL || "/"}index.html`, {
      cache: "no-store",
    });
    if (!response.ok) return;
    html = await response.text();
  } catch (e) {
    // ออฟไลน์หรือดึงไม่ได้ ปล่อยให้ใช้ของเดิมไปก่อน ดีกว่าขวางการใช้งาน
    return;
  }

  const match = html.match(BUNDLE_PATTERN);
  if (!match || match[0] === running) return;

  if (sessionStorage.getItem(GUARD_KEY) === match[0]) return;
  sessionStorage.setItem(GUARD_KEY, match[0]);

  // replace ไม่ใช่ assign เพื่อไม่ให้ปุ่ม back ของเบราว์เซอร์ย้อนกลับมาหน้าเวอร์ชันเก่า
  window.location.replace(buildReloadUrl(match[0]));
}
